import React, { useContext } from 'react'
import Swal from 'sweetalert2'
import { updatePasswordWithToken } from '../api/auth'
import { AuthContext } from '../context/AuthContext'

export const useConfig = () => {
  const { setLoading,checkToken } = useContext(AuthContext)
  const updatePassword = async (data) => {
    checkToken()
    try {
      setLoading(true)
      const response = await updatePasswordWithToken(data);
      setLoading(false)
      return [true];
    }
    catch (error) {
      setLoading(false)
      return [false, error.response.data.code];
    }
  }

  return {
    updatePassword
  }
}
